import {
  ArrowRight2,
  ArrowLeft2,
  Logout,
  Note,
  UserSquare,
} from "iconsax-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { login, selectUser } from "../../state/features/userSlice";
import { selectDrawer, changeDrawer } from "../../state/features/drawerSlice";
import { isAuthenticated, logout_function } from "../../requests/api_request";
import { Badge } from "antd";
import { Link } from "react-router-dom";
import execute from "../../requests/frappe";

const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="216"
      height="39"
      viewBox="0 0 216 39"
      fill="none"
    >
      <path
        d="M51.0355 14.3277V10.7842C51.5294 10.1211 52.5622 9.62376 53.5052 9.62376C55.1441 9.62376 56.2443 10.8049 56.2443 12.5249C56.2443 14.2655 55.1441 15.4467 53.5052 15.4467C52.5622 15.4467 51.5294 14.9701 51.0355 14.3277ZM51.0355 17.5396V16.2549C51.8886 17.2495 53.0786 17.7883 54.3808 17.7883C57.1199 17.7883 59.1855 15.8819 59.1855 12.5249C59.1855 9.27148 57.1424 7.28215 54.3808 7.28215C53.101 7.28215 51.8886 7.77949 51.0355 8.8156V3.71794H48.1841V17.5396H51.0355Z"
        fill="black"
      />
      <path
        d="M72.4082 17.5396V7.53082H69.5568V14.307C69.0629 14.8872 68.1872 15.4467 67.0871 15.4467C65.8747 15.4467 65.0889 14.9908 65.0889 13.6024V7.53082H62.2375V14.6385C62.2375 16.5864 63.3601 17.7883 65.74 17.7883C67.5137 17.7883 68.8159 17.0216 69.5568 16.2756V17.5396H72.4082Z"
        fill="black"
      />
      <path
        d="M80.0441 17.7883C83.0526 17.7883 84.759 16.4414 84.759 14.5971C84.759 10.5563 78.3153 11.7996 78.3153 10.3283C78.3153 9.76882 78.9888 9.35437 80.0216 9.35437C81.3463 9.35437 82.5811 9.89315 83.2322 10.5148L84.3773 8.64982C83.2996 7.86238 81.8402 7.28215 80.0216 7.28215C77.1478 7.28215 75.5762 8.75343 75.5762 10.4319C75.5762 14.3691 81.9974 13.0222 81.9974 14.6592C81.9974 15.2809 81.4136 15.7161 80.1788 15.7161C78.8317 15.7161 77.2376 15.0322 76.4293 14.3277L75.1945 16.2341C76.3395 17.2081 78.1581 17.7883 80.0441 17.7883Z"
        fill="black"
      />
      <path
        d="M89.1497 6.45327C90.0927 6.45327 90.856 5.74871 90.856 4.87838C90.856 4.00805 90.0927 3.32422 89.1497 3.32422C88.2292 3.32422 87.4658 4.00805 87.4658 4.87838C87.4658 5.74871 88.2292 6.45327 89.1497 6.45327ZM90.5866 17.5396V7.53082H87.7352V17.5396H90.5866Z"
        fill="black"
      />
      <path
        d="M104.505 17.5396V10.4734C104.505 8.52549 103.36 7.28215 100.958 7.28215C99.2065 7.28215 97.8594 8.0696 97.1634 8.8156V7.53082H94.312V17.5396H97.1634V10.7842C97.6574 10.204 98.5105 9.62376 99.6331 9.62376C100.846 9.62376 101.631 10.1004 101.631 11.4888V17.5396H104.505Z"
        fill="black"
      />
      <path
        d="M113.309 17.7883C114.992 17.7883 116.699 17.3117 117.776 16.3999L116.497 14.6592C115.801 15.2809 114.543 15.6332 113.623 15.6332C111.782 15.6332 110.704 14.6178 110.502 13.3952H118.562V12.7735C118.562 9.52015 116.384 7.28215 113.129 7.28215C109.851 7.28215 107.516 9.62376 107.516 12.5249C107.516 15.7368 110.008 17.7883 113.309 17.7883ZM115.823 11.5716H110.48C110.592 10.577 111.355 9.43726 113.129 9.43726C115.015 9.43726 115.733 10.6184 115.823 11.5716Z"
        fill="black"
      />
      <path
        d="M125.427 17.7883C128.435 17.7883 130.141 16.4414 130.141 14.5971C130.141 10.5563 123.698 11.7996 123.698 10.3283C123.698 9.76882 124.371 9.35437 125.404 9.35437C126.729 9.35437 127.964 9.89315 128.615 10.5148L129.76 8.64982C128.682 7.86238 127.223 7.28215 125.404 7.28215C122.53 7.28215 120.959 8.75343 120.959 10.4319C120.959 14.3691 127.38 13.0222 127.38 14.6592C127.38 15.2809 126.796 15.7161 125.561 15.7161C124.214 15.7161 122.62 15.0322 121.812 14.3277L120.577 16.2341C121.722 17.2081 123.541 17.7883 125.427 17.7883Z"
        fill="black"
      />
      <path
        d="M137.024 17.7883C140.033 17.7883 141.739 16.4414 141.739 14.5971C141.739 10.5563 135.296 11.7996 135.296 10.3283C135.296 9.76882 135.969 9.35437 137.002 9.35437C138.327 9.35437 139.561 9.89315 140.212 10.5148L141.358 8.64982C140.28 7.86238 138.82 7.28215 137.002 7.28215C134.128 7.28215 132.556 8.75343 132.556 10.4319C132.556 14.3691 138.978 13.0222 138.978 14.6592C138.978 15.2809 138.394 15.7161 137.159 15.7161C135.812 15.7161 134.218 15.0322 133.41 14.3277L132.175 16.2341C133.32 17.2081 135.138 17.7883 137.024 17.7883Z"
        fill="black"
      />
      <path
        d="M146.175 17.7676C147.163 17.7676 147.993 17.0009 147.993 16.0891C147.993 15.1773 147.163 14.4106 146.175 14.4106C145.187 14.4106 144.356 15.1773 144.356 16.0891C144.356 17.0009 145.187 17.7676 146.175 17.7676Z"
        fill="black"
      />
      <path
        d="M155.738 21.6012C158.41 21.6012 161.598 20.6687 161.598 16.8765V7.53082H158.746V8.8156C157.871 7.77949 156.681 7.28215 155.379 7.28215C152.639 7.28215 150.596 9.10571 150.596 12.3798C150.596 15.7161 152.684 17.4567 155.379 17.4567C156.726 17.4567 157.893 16.8972 158.746 15.9026V16.8765C158.746 18.9073 157.107 19.4461 155.738 19.4461C154.391 19.4461 153.223 19.0938 152.348 18.2235L151.068 20.1092C152.437 21.2075 153.897 21.6012 155.738 21.6012ZM156.299 15.1359C154.66 15.1359 153.537 14.0998 153.537 12.3798C153.537 10.6599 154.66 9.62376 156.299 9.62376C157.22 9.62376 158.252 10.1004 158.746 10.7428V13.9961C158.252 14.6385 157.22 15.1359 156.299 15.1359Z"
        fill="black"
      />
      <path
        d="M170.353 17.7883C173.945 17.7883 176.101 15.3638 176.101 12.5249C176.101 9.68593 173.945 7.28215 170.353 7.28215C166.783 7.28215 164.628 9.68593 164.628 12.5249C164.628 15.3638 166.783 17.7883 170.353 17.7883ZM170.353 15.4467C168.579 15.4467 167.591 14.0998 167.591 12.5249C167.591 10.9707 168.579 9.62376 170.353 9.62376C172.149 9.62376 173.137 10.9707 173.137 12.5249C173.137 14.0998 172.149 15.4467 170.353 15.4467Z"
        fill="black"
      />
      <path
        d="M185.018 17.5396L189.374 7.53082H186.321L183.469 14.4935L180.64 7.53082H177.587L181.943 17.5396H185.018Z"
        fill="black"
      />
      <path
        d="M191.557 17.7676C192.545 17.7676 193.376 17.0009 193.376 16.0891C193.376 15.1773 192.545 14.4106 191.557 14.4106C190.569 14.4106 189.739 15.1773 189.739 16.0891C189.739 17.0009 190.569 17.7676 191.557 17.7676Z"
        fill="black"
      />
      <path
        d="M201.771 17.7883C203.455 17.7883 205.162 17.3117 206.239 16.3999L204.959 14.6592C204.263 15.2809 203.006 15.6332 202.086 15.6332C200.245 15.6332 199.167 14.6178 198.965 13.3952H207.025V12.7735C207.025 9.52015 204.847 7.28215 201.592 7.28215C198.314 7.28215 195.979 9.62376 195.979 12.5249C195.979 15.7368 198.471 17.7883 201.771 17.7883ZM204.286 11.5716H198.942C199.055 10.577 199.818 9.43726 201.592 9.43726C203.478 9.43726 204.196 10.6184 204.286 11.5716Z"
        fill="black"
      />
      <path
        d="M213.62 17.7883C214.81 17.7883 215.573 17.4982 216 17.1459L215.394 15.1359C215.236 15.3016 214.832 15.4467 214.406 15.4467C213.777 15.4467 213.418 14.9701 213.418 14.3277V9.83098H215.618V7.53082H213.418V4.79549H210.566V7.53082H208.77V9.83098H210.566V15.0322C210.566 16.8351 211.622 17.7883 213.62 17.7883Z"
        fill="black"
      />
      <path
        d="M53.0998 34.3977V33.5308H49.1177V30.8364H53.0211V29.9695H49.1177V27.4509H53.0998V26.584H48.1841V34.3977H53.0998Z"
        fill="black"
      />
      <path
        d="M55.9383 34.5383C56.422 34.5383 56.7257 34.386 56.9394 34.1751L56.692 33.5074C56.5795 33.6363 56.3657 33.7534 56.1183 33.7534C55.7583 33.7534 55.5783 33.4488 55.5783 33.0271V29.5127H56.6807V28.7395H55.5783V27.1932H54.7234V28.7395H53.8235V29.5127H54.7234V33.2145C54.7234 34.058 55.1284 34.5383 55.9383 34.5383Z"
        fill="black"
      />
      <path
        d="M62.3832 34.3977V30.403C62.3832 29.1729 61.7871 28.5989 60.6509 28.5989C59.8298 28.5989 59.0873 29.0792 58.7161 29.5595V26.584H57.8725V34.3977H58.7161V30.2624C59.0311 29.8055 59.661 29.3838 60.3135 29.3838C61.0559 29.3838 61.5396 29.665 61.5396 30.6724V34.3977H62.3832Z"
        fill="black"
      />
      <path
        d="M64.4953 27.9312C64.8103 27.9312 65.0577 27.6735 65.0577 27.3454C65.0577 27.0174 64.8103 26.748 64.4953 26.748C64.1803 26.748 63.9216 27.0174 63.9216 27.3454C63.9216 27.6735 64.1803 27.9312 64.4953 27.9312ZM64.9115 34.3977V28.7395H64.0678V34.3977H64.9115Z"
        fill="black"
      />
      <path
        d="M68.9679 34.5383C70.6215 34.5383 71.6564 33.2028 71.6564 31.5628C71.6564 29.9227 70.6215 28.5989 68.9679 28.5989C67.3143 28.5989 66.2795 29.9227 66.2795 31.5628C66.2795 33.2028 67.3143 34.5383 68.9679 34.5383ZM68.9679 33.7534C67.8093 33.7534 67.1681 32.7225 67.1681 31.5628C67.1681 30.4147 67.8093 29.3838 68.9679 29.3838C70.1265 29.3838 70.7677 30.4147 70.7677 31.5628C70.7677 32.7225 70.1265 33.7534 68.9679 33.7534Z"
        fill="black"
      />
      <path
        d="M75.7089 34.5383C77.1375 34.5383 78.1274 33.3903 78.1274 31.5628C78.1274 29.7235 77.1375 28.5989 75.7089 28.5989C74.944 28.5989 74.2691 29.0089 73.8754 29.583V28.7395H73.0317V36.5532H73.8754V33.5425C74.3253 34.1634 74.9665 34.5383 75.7089 34.5383ZM75.4952 33.7534C74.8315 33.7534 74.1679 33.3317 73.8754 32.8397V30.2858C74.1679 29.7938 74.8315 29.3838 75.4952 29.3838C76.5864 29.3838 77.2388 30.3093 77.2388 31.5628C77.2388 32.8162 76.5864 33.7534 75.4952 33.7534Z"
        fill="black"
      />
      <path
        d="M79.8965 27.9312C80.2115 27.9312 80.4589 27.6735 80.4589 27.3454C80.4589 27.0174 80.2115 26.748 79.8965 26.748C79.5815 26.748 79.3228 27.0174 79.3228 27.3454C79.3228 27.6735 79.5815 27.9312 79.8965 27.9312ZM80.3127 34.3977V28.7395H79.469V34.3977H80.3127Z"
        fill="black"
      />
      <path
        d="M86.2364 34.3977V30.5084C86.2364 29.1378 85.2915 28.5989 84.1329 28.5989C83.2442 28.5989 82.5468 28.9035 81.9619 29.5361L82.3556 30.1453C82.8393 29.5947 83.368 29.3604 84.0204 29.3604C84.8078 29.3604 85.3928 29.7938 85.3928 30.5436V31.5628C84.9541 31.0473 84.3354 30.8013 83.5929 30.8013C82.6705 30.8013 81.7032 31.387 81.7032 32.6639C81.7032 33.894 82.6818 34.5383 83.5929 34.5383C84.3241 34.5383 84.9541 34.2689 85.3928 33.7534V34.3977H86.2364ZM83.9079 33.9057C83.1093 33.9057 82.5581 33.3903 82.5581 32.6639C82.5581 31.9493 83.1093 31.4339 83.9079 31.4339C84.4929 31.4339 85.0665 31.6682 85.3928 32.1251V33.2028C85.0665 33.6714 84.4929 33.9057 83.9079 33.9057Z"
        fill="black"
      />
      <path
        d="M94.303 34.3977C95.6754 34.3977 96.4741 33.5425 96.4741 32.2891C96.4741 31.3519 95.8104 30.4967 95.0117 30.3678C95.6979 30.2156 96.3278 29.5595 96.3278 28.5755C96.3278 27.404 95.5292 26.584 94.2243 26.584H90.8834V34.3977H94.303ZM94.0668 29.9695H91.8171V27.4509H94.0668C94.9105 27.4509 95.3604 28.0132 95.3604 28.7161C95.3604 29.4307 94.9105 29.9695 94.0668 29.9695ZM94.1231 33.5308H91.8171V30.8364H94.1231C95.0342 30.8364 95.5067 31.469 95.5067 32.1836C95.5067 33.0154 94.9892 33.5308 94.1231 33.5308Z"
        fill="black"
      />
      <path
        d="M102.435 34.3977V28.7395H101.591V32.8982C101.276 33.3551 100.646 33.7534 99.9939 33.7534C99.2515 33.7534 98.7678 33.4605 98.7678 32.4648V28.7395H97.9241V32.7342C97.9241 33.9526 98.5203 34.5383 99.6564 34.5383C100.466 34.5383 101.175 34.0931 101.591 33.6011V34.3977H102.435Z"
        fill="black"
      />
      <path
        d="M105.852 34.5383C107.247 34.5383 107.978 33.7768 107.978 32.8279C107.978 30.6256 104.615 31.4339 104.615 30.2038C104.615 29.7001 105.076 29.3135 105.818 29.3135C106.527 29.3135 107.112 29.6181 107.438 30.0281L107.832 29.419C107.404 28.9621 106.752 28.5989 105.818 28.5989C104.525 28.5989 103.805 29.337 103.805 30.2273C103.805 32.3242 107.168 31.4807 107.168 32.8514C107.168 33.4137 106.707 33.8237 105.875 33.8237C105.132 33.8237 104.446 33.4488 104.086 33.0154L103.659 33.648C104.21 34.2454 104.952 34.5383 105.852 34.5383Z"
        fill="black"
      />
      <path
        d="M109.776 27.9312C110.091 27.9312 110.339 27.6735 110.339 27.3454C110.339 27.0174 110.091 26.748 109.776 26.748C109.461 26.748 109.202 27.0174 109.202 27.3454C109.202 27.6735 109.461 27.9312 109.776 27.9312ZM110.192 34.3977V28.7395H109.349V34.3977H110.192Z"
        fill="black"
      />
      <path
        d="M116.386 34.3977V30.4264C116.386 29.1964 115.79 28.5989 114.665 28.5989C113.844 28.5989 113.101 29.0792 112.719 29.5595V28.7395H111.875V34.3977H112.719V30.2624C113.045 29.8055 113.664 29.3838 114.328 29.3838C115.059 29.3838 115.554 29.6884 115.554 30.6959V34.3977H116.386Z"
        fill="black"
      />
      <path
        d="M120.545 34.5383C121.423 34.5383 122.154 34.222 122.705 33.6597L122.3 33.0857C121.861 33.5543 121.243 33.812 120.613 33.812C119.443 33.812 118.734 32.9217 118.667 31.8556H123.054V31.633C123.054 29.9344 122.086 28.5989 120.444 28.5989C118.892 28.5989 117.767 29.9227 117.767 31.5628C117.767 33.3317 118.926 34.5383 120.545 34.5383ZM122.221 31.1996H118.656C118.701 30.3444 119.274 29.3252 120.433 29.3252C121.67 29.3252 122.21 30.3678 122.221 31.1996Z"
        fill="black"
      />
      <path
        d="M126.153 34.5383C127.547 34.5383 128.279 33.7768 128.279 32.8279C128.279 30.6256 124.915 31.4339 124.915 30.2038C124.915 29.7001 125.376 29.3135 126.119 29.3135C126.828 29.3135 127.413 29.6181 127.739 30.0281L128.132 29.419C127.705 28.9621 127.053 28.5989 126.119 28.5989C124.825 28.5989 124.105 29.337 124.105 30.2273C124.105 32.3242 127.469 31.4807 127.469 32.8514C127.469 33.4137 127.008 33.8237 126.175 33.8237C125.433 33.8237 124.747 33.4488 124.387 33.0154L123.959 33.648C124.51 34.2454 125.253 34.5383 126.153 34.5383Z"
        fill="black"
      />
      <path
        d="M131.382 34.5383C132.776 34.5383 133.508 33.7768 133.508 32.8279C133.508 30.6256 130.144 31.4339 130.144 30.2038C130.144 29.7001 130.605 29.3135 131.348 29.3135C132.057 29.3135 132.641 29.6181 132.968 30.0281L133.361 29.419C132.934 28.9621 132.281 28.5989 131.348 28.5989C130.054 28.5989 129.334 29.337 129.334 30.2273C129.334 32.3242 132.698 31.4807 132.698 32.8514C132.698 33.4137 132.236 33.8237 131.404 33.8237C130.662 33.8237 129.975 33.4488 129.616 33.0154L129.188 33.648C129.739 34.2454 130.482 34.5383 131.382 34.5383Z"
        fill="black"
      />
      <path
        d="M138.757 34.3977V31.2933H140.838C142.334 31.2933 143.189 30.2156 143.189 28.9386C143.189 27.6617 142.345 26.584 140.838 26.584H137.823V34.3977H138.757ZM140.725 30.4264H138.757V27.4509H140.725C141.614 27.4509 142.221 28.06 142.221 28.9386C142.221 29.8173 141.614 30.4264 140.725 30.4264Z"
        fill="black"
      />
      <path
        d="M146.622 34.5383C148.276 34.5383 149.311 33.2028 149.311 31.5628C149.311 29.9227 148.276 28.5989 146.622 28.5989C144.968 28.5989 143.934 29.9227 143.934 31.5628C143.934 33.2028 144.968 34.5383 146.622 34.5383ZM146.622 33.7534C145.463 33.7534 144.822 32.7225 144.822 31.5628C144.822 30.4147 145.463 29.3838 146.622 29.3838C147.781 29.3838 148.422 30.4147 148.422 31.5628C148.422 32.7225 147.781 33.7534 146.622 33.7534Z"
        fill="black"
      />
      <path
        d="M151.53 34.3977V30.3913C151.777 29.9344 152.486 29.4892 153.014 29.4892C153.138 29.4892 153.239 29.501 153.341 29.5127V28.6106C152.598 28.6106 151.968 29.0558 151.53 29.6415V28.7395H150.686V34.3977H151.53Z"
        fill="black"
      />
      <path
        d="M155.782 34.5383C156.266 34.5383 156.57 34.386 156.784 34.1751L156.536 33.5074C156.424 33.6363 156.21 33.7534 155.962 33.7534C155.602 33.7534 155.422 33.4488 155.422 33.0271V29.5127H156.525V28.7395H155.422V27.1932H154.568V28.7395H153.668V29.5127H154.568V33.2145C154.568 34.058 154.973 34.5383 155.782 34.5383Z"
        fill="black"
      />
      <path
        d="M161.946 34.3977V30.5084C161.946 29.1378 161.001 28.5989 159.843 28.5989C158.954 28.5989 158.257 28.9035 157.672 29.5361L158.065 30.1453C158.549 29.5947 159.078 29.3604 159.73 29.3604C160.518 29.3604 161.103 29.7938 161.103 30.5436V31.5628C160.664 31.0473 160.045 30.8013 159.303 30.8013C158.38 30.8013 157.413 31.387 157.413 32.6639C157.413 33.894 158.392 34.5383 159.303 34.5383C160.034 34.5383 160.664 34.2689 161.103 33.7534V34.3977H161.946ZM159.618 33.9057C158.819 33.9057 158.268 33.3903 158.268 32.6639C158.268 31.9493 158.819 31.4339 159.618 31.4339C160.203 31.4339 160.776 31.6682 161.103 32.1251V33.2028C160.776 33.6714 160.203 33.9057 159.618 33.9057Z"
        fill="black"
      />
      <path d="M164.492 34.3977V26.584H163.648V34.3977H164.492Z" fill="black" />
      <path
        d="M19.1077 38.2155C29.6606 38.2155 38.2155 29.6606 38.2155 19.1077C38.2155 8.55482 29.6606 0 19.1077 0C8.55482 0 0 8.55482 0 19.1077C0 29.6606 8.55482 38.2155 19.1077 38.2155Z"
        fill="#0F47AF"
      />
      <path
        d="M4.98438 14.1133H15.7735L18.2129 6.21907L18.8636 8.32446L15.3184 19.7965L14.2658 18.9922L15.3714 15.4145H6.68763L4.98438 14.1133ZM10.3789 31.5704L13.7129 20.7814L7.32639 15.9025H9.43172L18.7128 22.9925L17.66 23.7966L14.7657 21.5857L12.0822 30.2692L10.3789 31.5704ZM27.8361 31.5704L19.1076 24.9024L12.7209 29.7813L13.3715 27.676L22.6525 20.5859L23.0547 21.887L20.1602 24.0983L27.1854 29.4651L27.8361 31.5704ZM33.2306 14.1133L24.5021 20.7814L26.9414 28.6758L25.2381 27.3746L21.6932 15.9025H22.9943L24.0999 19.4802L31.1251 14.1133H33.2306ZM19.1076 3.32422L22.4414 14.1133H30.3356L28.6326 15.4145H17.1605L17.5625 14.1133H21.1403L18.4569 5.42955L19.1076 3.32422Z"
        fill="#FCDD09"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6863 6.64453L15.3825 13.4409L14.8853 13.8208L10.1891 7.02437L10.6863 6.64453ZM28.026 7.02437L23.3298 13.8207L22.8326 13.4409L27.5288 6.64453L28.026 7.02437ZM4.98438 23.8669L12.583 21.2708L12.7729 21.8854L5.1743 24.4815L4.98438 23.8669ZM33.0407 24.4815L25.4422 21.8854L25.6321 21.2708L33.2306 23.8669L33.0407 24.4815ZM18.8003 34.8907V26.49H19.4149V34.8907H18.8003Z"
        fill="#FCDD09"
      />
    </svg>
  );
};
const CompressedLogo = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 50 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5705_13748)">
        <path
          d="M11.9041 9.82192C3.24578 16.2264 1.41869 28.4372 7.82315 37.0955C14.2276 45.7538 26.4384 47.5809 35.0967 41.1764C43.755 34.7719 45.5821 22.5611 39.1776 13.9028C32.7732 5.24455 20.5624 3.41746 11.9041 9.82192Z"
          fill="#0F47AF"
        />
        <path
          d="M38.1187 21.0249L29.2666 27.5727L32.0561 35.5301L30.2445 34.1976L26.1909 22.6337L27.5426 22.6547L28.8069 26.261L35.9315 20.991L38.1187 21.0249ZM23.0981 9.9758L26.9105 20.8512L35.1113 20.9783L33.384 22.256L21.4663 22.0715L21.8421 20.7727L25.5585 20.8303L22.4903 12.0771L23.0981 9.9758ZM8.77507 20.5704L19.9833 20.7441L22.2624 12.865L23.0063 14.9872L19.6944 26.4369L18.5748 25.6135L19.6077 22.0426L10.5866 21.9029L8.77507 20.5704ZM14.9436 38.1672L18.0583 27.3991L11.2659 22.4024L13.453 22.4362L23.3239 29.6974L22.2564 30.487L19.178 28.2226L16.6711 36.8894L14.9436 38.1672ZM33.0789 38.4482L23.7958 31.6194L17.3189 36.4103L17.9265 34.3092L27.3389 27.3469L27.7988 28.6584L24.8633 30.8297L32.335 36.326L33.0789 38.4482Z"
          fill="#FCDD09"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.9746 30.6147L29.9969 27.8886L30.1743 27.2752L38.1521 30.0013L37.9746 30.6147ZM23.5174 40.8264L23.2458 32.4002L23.8843 32.41L24.1559 40.8363L23.5174 40.8264ZM32.2007 13.0239L27.5419 19.7655L27.0131 19.3765L31.6719 12.6349L32.2007 13.0239ZM8.80851 29.5468L16.6184 27.0653L16.8355 27.6848L9.02566 30.1663L8.80851 29.5468ZM14.175 12.364L19.2733 19.2565L18.7691 19.6295L13.6707 12.737L14.175 12.364Z"
          fill="#FCDD09"
        />
      </g>
      <defs>
        <clipPath id="clip0_5705_13748">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

function ActionItem({
  icon,
  title,
  badge = 0,
  url,
  negative = false,
  click,
}: any) {
  return (
    <Link to={url}>
      <div className="hover:text-blue_btn" onClick={click}>
        <Badge count={badge} overflowCount={9}>
          <div style={{ color: negative ? "red" : "inherit", fontSize: 17 }}>
            {icon}
          </div>
        </Badge>
        <span>{title}</span>
      </div>
    </Link>
  );
}

export const Sidebar = (props: any) => {
  const navigate = useNavigate();
  let location = useLocation();
  let Params = new URLSearchParams(location.search);
  let status = Params.get("status");
  const [Auth, setAuth] = useState<any>();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const drawer = useSelector(selectDrawer);
  const [Path, setPath] = useState("");
  const [data, setData] = useState<any>("");
  // const heightval = window.innerHeight;
  // const viewportHeight = `h-[${heightval.toString()}px]`;
  const [isHovered, setIsHovered] = useState(false);
  const [widthval, setWidthval] = useState("350px");
  const [isLeft, setIsLeft] = useState(true);

  const Fetch_Data = async () => {
    const temp_data =
      user &&
      (await execute("GET_USER_APPLICATIONS", {
        // user: user?.name,
      }));
    setData(temp_data);
  };

  useEffect(() => {
    Fetch_Data();
  }, [user]);

  const handleButtonClick = () => {
    // Toggle the visibility of the div
    isLeft ? setWidthval("5%") : setWidthval("350px");
    dispatch(changeDrawer(!drawer));
    setIsLeft(!isLeft);
  };

  // Function to update the variable when the div is hovered
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  // Function to update the variable when the div is no longer hovered
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    const Auth_checker = async () => {
      setAuth(await isAuthenticated());
    };
    Auth_checker();
  }, []);

  useEffect(() => {
    if (Auth != user) {
      dispatch(login(Auth));
    }
  }, [Auth, widthval]);

  const pathChecker = () => {
    setPath(window.location.pathname.split("/")[1]);
  };
  useEffect(() => {
    pathChecker();
  }, [window.location.pathname, status]);

  return (
    (data || Auth?.name === "Administrator") && (
      <div
        className={` top-0 left-0 bottom-0 hidden md:block mt-[2px] mr-5 md:mr-[1%] bg-white h-full w-[${widthval}] shadow-md rounded-r-md `}
      >
        <div className="flex flex-col h-full pb-7 justify-around ">
          <div className=" sticky flex justify-center items-center h-[15%]">
            {isLeft ? (
              <div className=" h-full pl-[10%] mt-[15%] nmd:mr-[-3%] lg:mr-[4%]">
                <div className="h-[40%] border-b-2 border-[#0F47AF] pb-2">
                  <Logo />
                </div>
                <div className="h-[50%] flex pt-2">
                  <p className="text-black text-[32px] font-bold">NBP</p>
                  <p className="ml-3 w-[50%] font-semibold">
                    Evaluation Dashboard
                  </p>
                </div>
              </div>
            ) : (
              <div className=" h-full mx-[5%] pl-[25%] mt-[-50%]">
                <CompressedLogo />
              </div>
            )}
            <button
              className=" mt-[12%] bg-[#1890FF] rounded-[50%] border-none"
              onClick={handleButtonClick}
            >
              {isLeft ? (
                <ArrowLeft2 className="m-1" size="20" color="#ffff" />
              ) : (
                <ArrowRight2 className="m-1" size="20" color="#ffff" />
              )}
            </button>
          </div>

          <div className=" mt-5 mr-1">
            <div
              className={`  py-2 flex flex-col items-center justify-center md:justify-between cursor-pointer `}
            >
              <p
                className={` ${
                  Path === "" ||
                  Path === "application" ||
                  Path === "evaluate" ||
                  Path === "certificate"
                    ? " bg-[#1890FF] text-white rounded-r-[50px]"
                    : "hover:text-sidebar_hover"
                } hidden md:flex items-center md:px-1 w-full py-3 mb-2 ${
                  isLeft ? "" : "justify-center"
                }`}
                onClick={() => {
                  navigate("/?status=all");
                }}
              >
                <Note
                  className={`mr-4 ${
                    (Path === "" ||
                      Path === "application" ||
                      Path === "evaluate" ||
                      Path === "certificate") &&
                    !isLeft
                      ? "mr-6"
                      : "ml-4"
                  } ${isLeft ? "ml-0" : ""} `}
                />
                {isLeft && "Application"}
              </p>
              <div className=" pl-12 w-full pr-5">
                <p
                  className={` ${
                    status === "pending" ? "text-sidebar_hover" : ""
                  } flex justify-between  hover:text-sidebar_hover pl-3`}
                  onClick={() => {
                    navigate("/?status=pending");
                  }}
                >
                  {isLeft && (
                    <>
                      <p className="hidden md:flex justify-between w-[80%]">
                        New
                      </p>
                      <p>{data?.new}</p>
                    </>
                  )}
                </p>

                <p
                  className={` ${
                    status === "approved" ? "text-sidebar_hover" : ""
                  } flex justify-between hover:text-sidebar_hover pl-3`}
                  onClick={() => {
                    navigate("/?status=approved");
                  }}
                >
                  {isLeft && (
                    <>
                      <p className="hidden md:flex justify-between w-[80%]">
                        Completed
                      </p>
                      <p>{data?.completed}</p>
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>

          {isLeft ? (
            <div className="nxl:mt-[50%] px-2 ">
              {Auth && (
                <div className="hidden md:flex items-center">
                  <div className="flex justify-center items-center w-full bg-blue rounded-[50px] px-3">
                    <UserSquare color="#FFFFFF" />
                    <p
                      className="h-[40px] p-2 flex items-center text-white "
                      // onMouseEnter={handleMouseEnter}
                      // onMouseLeave={handleMouseLeave}
                    >
                      {user?.full_name}
                    </p>
                    <Logout
                      className="ml-4 cursor-pointer"
                      size="20"
                      color="#ffffff"
                      onClick={async () => {
                        await logout_function();
                        navigate("/signin", { replace: true });
                        window.location.reload();
                      }}
                    />
                  </div>
                </div>
              )}

              <p className=" flex justify-center text-center text-[11px] mt-5">
                Developed & powered by{" "}
                <a
                  className="text-blue ml-1"
                  target="_blank"
                  href="https://360ground.com"
                >
                  360Ground
                </a>
              </p>
            </div>
          ) : (
            <Logout
              className=" mx-auto cursor-pointer hover:text-sidebar_hover"
              size="35"
              onClick={async () => {
                await logout_function();
                navigate("/signin", { replace: true });
                window.location.reload();
              }}
            />
          )}
        </div>
      </div>
    )
  );
};
